import React, { Component } from 'react';
import classes from '../../GeneralFormComponent/GeneralFormComponent.module.scss';
import classNames from './InputField.module.scss';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/es/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormHelperText from '@material-ui/core/FormHelperText';
import Directives from '../../../Directives/Directives';
import { IInputField } from '../formFields';

interface IProps extends IInputField {
  errors: any;
  touched: any;

  onChange(name: string): any;
}

class InputField extends Component<IProps> {
  render() {

    let inputProps = {};
    if (this.props.suffix) {
      inputProps = {
        endAdornment: <InputAdornment position='end'>{this.props.suffix}</InputAdornment>,
      };
    }

    return (
      <FormControl className={classNames.filed}>
        <TextField
          name={this.props.name}
          type={this.props.type}
          value={this.props.value}
          variant='outlined'
          multiline={(!!this.props.multiLine)}
          rowsMax={this.props.rowsMax ? this.props.rowsMax : 1}
          onChange={this.props.onChange(this.props.name)}
          label={this.props.label}
          InputProps={{...inputProps,className: classNames.input}}
          disabled={this.props.disabled}
        />
        <Directives dIf={this.props.errors[ this.props.name ] && this.props.touched[ this.props.name ]}>
          <FormHelperText className={classes.error}>{this.props.errors[ this.props.name ]}</FormHelperText>
        </Directives>
      </FormControl>
    );
  }
}

export default InputField;
